import React, { Component } from 'react';
import * as api from '../../api';
import { Grid,Message } from 'semantic-ui-react';
import 'semantic-ui-css/semantic.min.css';
import "./dashboard.scss";
import Card from '../../components/card/Card'
import ConsumptionChart from "../../components/charts/custom/consumption-chart";
import {Helmet} from "react-helmet";
import {collateUtilityData} from "../../helpers/chart-dataset-helpers";
import MonthlyUtilityChart from "../../components/charts/custom/monthly-utility-chart";
import SiteRankedChart from "../../components/charts/custom/site-ranked-chart";
import {AuthService} from "../../services/auth-service"
import Slider from "react-slick";
import {translateSiteName} from "../../helpers/data-helpers";
import ReactGA from 'react-ga';
import appData from "../about/release_notes.json"
import { BreadcrumbContext } from '../../components/header/breadcrumbcontext'; // Adjust the path as necessary

class Dashboard extends Component {
    static contextType = BreadcrumbContext;


    componentWillUnmount() {
        //this.context.removeBreadcrumb('/');
    }

    state = {
        sitesList:[],
        //caseList: null,
        metersList:[],
        siteConsumption: [],
        costData:[],
        consumptionData: [],
        co2Data: [],
        releases: [],
       
        //showLatestFeatures: true
       
    };

    sliderSettings = {
        dots: true,
        arrows: true,
        className: "default-slider"
    };

   

    authService = new AuthService();
    //clientPropertyRef
    //address
    // concat 
    get siteLookups() {
        return this.state.sitesList.map(x => { return { key: x.siteKey, 
            
            name: translateSiteName(x)


        
        }});
    }

    render() {
    
        return (
            <div className="main-container">
                <Helmet>
                    <title>Inenco Portal | Dashboard</title>
                </Helmet>
                { (this.state.releases && this.state.releaseLatest)  && (
                    (this.authService.getUserData(AuthService.LASTVERSION) !== "null") ? (
                    (this.authService.getUserData(AuthService.LASTVERSION) !== this.state.releaseLatest.version )&& 
               
          <Message color='blue' size='large' fluid>
            <Message.Header>Experience our latest innovative portal features!</Message.Header>
            <Message.List>
                { JSON.parse(this.state.releaseLatest.features).map((feature, index) => (
                  <li key={index}>{feature}</li>
                ))}
            </Message.List>
            <Message.Content>
           To find out more about these changes, please visit the User Guide section. 
           </Message.Content>
           
          </Message>
           ) : (
            <Message color='blue' size='large' fluid>
            <Message.Header>Welcome to the inenco Portal</Message.Header>

            <Message.Content>
            Please see our User Guide section for more details on how to navigate through the site. If you have any further queries about using our Portal, please reach out to your Account Manager
           </Message.Content>
           
          </Message>

        )
        ) 
        }
                
                <Grid padded stackable columns='equal'>
                
                    <Grid.Row>
                        <Grid.Column>
                            <h2>Welcome, {this.authService.getUserData(AuthService.FIRSTNAME_KEY)} {this.authService.getUserData(AuthService.SURNAME_KEY)} ({this.authService.getUserData(AuthService.CUSTOMER_NAME_KEY)}) </h2>
                        </Grid.Column>
                    </Grid.Row>

                    <Grid.Row columns='five'>
                        <Grid.Column>
                            <Card popupText={"This is the total number of your active sites."} metric={ this.state.caseList ? this.state.sitesList.length : null} title={"Total Sites"} link={'/sites/'}/>
                        </Grid.Column>
                        <Grid.Column>
                            <Card popupText={"This is the total number of your active meters."} metric={ this.state.caseList ? this.state.metersList.length : null} title={"Total Meters"} link={"/meters/"}/>
                        </Grid.Column>
                        <Grid.Column>
                            <Card popupText={"This is the total number of cases closed in the last 12 months."} 
                               metric={ this.state.caseList ? this.state.caseList.filter(x => x.status === "Closed").length : null} 
                            title={"Closed Cases"} link={"/service-management/"}   linkState={{ cardClicked: "Closed" }}  />
                                  
                        </Grid.Column>
                        <Grid.Column>
                            <Card popupText={"This is the total number of cases still open to date."} 
                                    metric={ this.state.caseList  ? this.state.caseList.filter(x => x.status !== "Closed").length : null} 

                            //metric={this.state.caseList.filter(x => x.status !== "Closed").length} 
                             title={"Open Cases"} link={"/service-management/"}     linkState={{ cardClicked: "Open" }}  />
                                                           

                        </Grid.Column>
                    </Grid.Row>

                    <Grid.Row>
                        <Grid.Column>
                            {!!this.state.costData.length>0  && <MonthlyUtilityChart data={this.state.costData} label={"Total Cost (£)"} title={"Monthly Utility Cost"} 
 /> }
                        </Grid.Column>
                        <Grid.Column width={6}>
                        {!!this.state.siteConsumption.length >0 && 
                            <Slider {...this.sliderSettings}>
                                <div className="slider-content">
                                    {!!this.state.siteConsumption.length >0 && <SiteRankedChart data={this.state.siteConsumption} siteLookups={this.siteLookups} title={"Highest Costing Sites"} months={12} comparisonField={"totalNet"} count={5} label={""}/>}
                                </div>
                                <div className="slider-content">
                                    {!!this.state.siteConsumption.length >0 && <SiteRankedChart data={this.state.siteConsumption} siteLookups={this.siteLookups} title={"Lowest Costing Sites"} months={12} comparisonField={"totalNet"} order={"asc"} count={5} label={""} />}
                                </div>
                            </Slider>
                        }
                        </Grid.Column>
                    </Grid.Row>

                    <Grid.Row>
                        <Grid.Column>
                            {!!this.state.consumptionData.length>0 && <ConsumptionChart data={this.state.consumptionData} />}
                        </Grid.Column>
                        <Grid.Column  width={6}>
                        {!!this.state.siteConsumption.length >0 &&
                            <Slider {...this.sliderSettings}>
                                <div className="slider-content">
                                    {!!this.state.siteConsumption.length >0 && <SiteRankedChart data={this.state.siteConsumption} siteLookups={this.siteLookups} title={"Highest Consumption Sites"} months={12} comparisonField={"totalCons"} count={5}  label={"Total Consumption (kWh)"}/>}
                                </div>
                                <div className="slider-content">
                                    {!!this.state.siteConsumption.length >0 && <SiteRankedChart data={this.state.siteConsumption} siteLookups={this.siteLookups} title={"Lowest Consumption Sites"} months={12} comparisonField={"totalCons"} order={"asc"} count={5} label={"Total Consumption (kWh)"} />}
                                </div>
                            </Slider>
    }
                        </Grid.Column>
                    </Grid.Row>

                    <Grid.Row>
                        <Grid.Column>
                            {!!this.state.co2Data.length && <MonthlyUtilityChart data={this.state.co2Data} label={"CO2e Tonnes"} title={"Monthly Utility CO2e"}/> }
                        </Grid.Column>
                        <Grid.Column width={6}>
                        {!!this.state.siteConsumption.length >0 &&
                            <Slider {...this.sliderSettings}>
                                <div className="slider-content">
                                    {!!this.state.siteConsumption.length >0 && <SiteRankedChart data={this.state.siteConsumption} utilitiesToUse={["Gas", "Electricity"]} siteLookups={this.siteLookups} title={"Highest CO2e Sites"} months={12} comparisonField={"tonnesCO2"} count={5} label={"CO2e Tonnes"} />}
                                </div>
                                <div className="slider-content">
                                    {!!this.state.siteConsumption.length >0 && <SiteRankedChart data={this.state.siteConsumption} utilitiesToUse={["Gas", "Electricity"]} siteLookups={this.siteLookups} title={"Lowest CO2e Sites"} months={12} comparisonField={"tonnesCO2"} order={"asc"} count={5} label={"CO2e Tonnes"} />}
                                </div>
                            </Slider>
    }
                        </Grid.Column>
                    </Grid.Row>

                </Grid>
            </div>
        );
    }

    componentDidMount = () => {
        //this.context.addBreadcrumb({ title: 'Dashboard', path: '/' });

        this.fetchData();
        ReactGA.pageview('dashboard');

        const { messageContent, messageHeader } = appData.dashboard;
        this.setState({ dashboardMessage: messageContent, dashboardMessageHeader: messageHeader });
    
    };

    fetchData = () => {
        return Promise.all([
            api.getSiteList(),
            api.getMetersList(this.props.customerId),
            api.getCaseList(this.props.customerId),
            api.getMonthlyCostConsumption(),
            api.getCustomerConsumption(this.props.customerId, true),
            api.getReleases(),
           ])
          .then(([sitesList, metersList, caseList, costAndConsumptionData, siteConsumption, releases])=> {

         


          this.setState({sitesList : sitesList.data, metersList,
              caseList: caseList.data,
              costData: collateUtilityData(costAndConsumptionData, "cost"),
              consumptionData: collateUtilityData(costAndConsumptionData, "consumption"),
              co2Data: collateUtilityData(costAndConsumptionData, "tonnesCO2", ["Gas", "Electricity"]),
              siteConsumption: siteConsumption.data,
              releases: releases,
              releaseLatest: releases.length > 0 ? releases[0] : null, // Protect against empty array releaseLatest : releases[0]
          
          })
         
        });
    };

    componentDidUpdate = () => {
    };
}

export default Dashboard;